import React from 'react';

export default function LocalDemoIvrPanel({ t, disabled, onExample }) {
  return (
    <aside className="mb-4 rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm" role="note">
      <p>{t('Local demo: use fictional patient details only. No insurance check is performed.')}</p>
      <button
        type="button"
        className="mt-2 font-semibold text-blue-700 underline"
        disabled={disabled}
        onClick={onExample}
      >
        {t('Use example patient')}
      </button>
    </aside>
  );
}
